import { useLoaderData } from 'react-router';

import { DetailBadgeRow } from '~/ui-rocco/pages/detail-shared';
import type { loader } from '~/routes/_app.product.$urlSegment';

/**
 * The supplier's brand badge, straddling the gallery's lower edge on the
 * right. The shared row owns the geometry, so the badge sits where the
 * project's and the article's do.
 */
export const ProductSupplierLogoBadge = () => {
    const { product } = useLoaderData<typeof loader>();
    const professional = product.Professional;
    if (!professional?.CompanyLogo) return null;

    return (
        <DetailBadgeRow
            logo={{
                src: professional.CompanyLogo,
                alt: `${professional.Title} logo`,
                background: professional.LogoBackgroundColor,
                link: professional.Link,
                ariaLabel: `${professional.Title} profile`,
            }}
        />
    );
};
